import React from "react";
import i18n from 'i18next';

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
    };

  }
  handleChange(e) {
    this.setState({
      lang: e.target.value,
    })
  }
  render() {
    const msg = this.props.Message;
    return (
      <nav className="navbar navbar-default navbar-expand-lg fixed-top">
        <button className="navbar-toggler" type="button" data-toggle="collapse" href="#navbarNavDropdown" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown"
          aria-expanded="false" aria-label="Toggle navigation">
          <span className="icon ios-arrow-up"></span>
        </button>
        <div className="nav-logo-mobile">
          <img src="images/logo_shopee_v.png" alt="Company Logo" />
          {/* <h1 className="logo-text">National<br />Data Science<br />Challenge</h1> */}
          {/* <img src="images/logo_shopee_h.png" alt="Company Logo" /> */}
        </div>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <div className="container">
            <a className="nav-logo-desktop" href="/">
              <img src="images/logo_shopee_h.png" alt="Company Logo" />
              {/* <h1 className="logo-text">National<br />Data Science<br />Challenge</h1> */}
            </a>
            <ul className="navbar-nav ml-auto" data-easing="easeInOutExpo" data-speed="1250" data-offset="65">
              <li className="nav-item">
                <a className="nav-link" href="#about">{i18n.t(msg.navAbout)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#timeline">{i18n.t(msg.navTimeline)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#prizes">{i18n.t(msg.navPrizes)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#theme">{i18n.t(msg.navTheme)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#judge">{i18n.t(msg.navJudge)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#faq">{i18n.t(msg.navFaq)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#partners">{i18n.t(msg.navPartners)}</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href={msg.careerLink} target="_blank" rel="noopener noreferrer">{i18n.t(msg.career)}</a>
              </li>
              {/* <li className="nav-item">
                <div className="nav-link">
                  <img src="images/icon_lang.svg" alt="select language" className="icon-lang" />
                  <select name="" id="lang" onChange={e => this.props.onInputChange(e.target.value)} defaultValue={this.props.value} className="select-lang">
                    <option value='id'>ID</option>
                    <option value='en'>EN</option>
                  </select>
                </div>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;